import ResponseEntity, { InputEntity } from "../../..";
import {
  IsBoolean,
  IsInt,
  IsNumber,
  IsString,
  ValidateIf,
} from "class-validator";

export default class TransmedRegistrationField extends ResponseEntity {
  @IsInt() public readonly id!: number;
  @IsInt() public readonly field!: number;
  @IsNumber() public readonly quantity!: number;

  @ValidateIf((obj) => obj.proof !== null)
  @IsString()
  public readonly proof!: string | null;

  @ValidateIf((obj) => obj.answer !== null)
  @IsString()
  public readonly answer!: string | null;

  @ValidateIf((obj) => obj.validator !== null)
  @IsString()
  public readonly validator!: string | null;

  @IsBoolean() public readonly valid!: boolean;
}

export class TransmedRegistrationFieldInput extends InputEntity {
  public constructor(
    public field: number,
    public quantity: number,
    public proof: File | null
  ) {
    super();
  }
}
